import React from 'react';
import StatsCard from './StatsCard';

const Projects = () => {
  return (
    <StatsCard title="Projets" loading={false} error={null}>
      <div style={{ textAlign: 'center', color: '#666', padding: '2rem' }}>
        <p>Contenu à venir...</p>
      </div>
    </StatsCard>
  );
};

export default Projects;
